module.exports = __webpack_public_path__ + "static/media/tower.6b545612.svg";